import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import ThemeConsumer from "shared/components/ThemeConsumer"
import Typograph from "components/Typograph"

const DescriptionList = ({
  first = false,
  last = false,
  description,
  value,
  theme,
  direction = "row",
  hasDivider,
  classNames
}) => {
  const isRow = direction === "row"
  const containerDescriptionItem = classnames(
    "u-flex u-flexJustifyBetween",
    {
      [theme.pb3]: !last && isRow,
      [theme.pt3]: !first && isRow,
      [theme.dividerBottom]: !last && hasDivider,
      "u-flexCol": direction === "col"
    },
    classNames
  )

  return (
    <dl className={containerDescriptionItem}>
      <Description description={description} />
      <Description description={value} type="value" />
    </dl>
  )
}

DescriptionList.propTypes = {
  first: PropTypes.bool,
  last: PropTypes.bool,
  description: PropTypes.string,
  value: PropTypes.string,
  theme: PropTypes.shape({
    pb3: PropTypes.string,
    pt3: PropTypes.string,
    dividerBottom: PropTypes.string
  }),
  direction: PropTypes.string,
  hasDivider: PropTypes.bool,
  classNames: PropTypes.string
}

export default ThemeConsumer("UIDescriptionList")(DescriptionList)

const Description = ({ description, type = "key" }) => {
  const weight = type === "value" ? "bold" : "regular"

  return (
    <Typograph htmlTag="dt" size="medium" color="outer_space" weight={weight}>
      {description}
    </Typograph>
  )
}

Description.propTypes = {
  description: PropTypes.string,
  type: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/DescriptionList/index.js